import my from './my/ms-my.json';

export default my;
